import accountingRoutes from 'modules/accounting/routes'
import etpRoutes from 'modules/assets/etp/routes'
import etrRoutes from 'modules/assets/etr/routes'
import authRoutes, { ROUTE_NAMES as AUTH_ROUTES } from 'modules/auth/routes'
import rolesRoutes from 'modules/authorization/routes'
import companiesRoutes from 'modules/companies/routes'
import creditRoutes from 'modules/credit-note/routes'
import debtCollectionRoutes from 'modules/debt-collection/routes'
import instructionsEurRoutes from 'modules/instructions-eur/routes'
import instructionsGBPRoutes from 'modules/instructions-gbp/routes'
import accountStatements from 'modules/investors/account-statements/routes'
import investorsCompaniesRoutes from 'modules/investors/companies/routes'
import investorsPositions from 'modules/investors/positions/routes'
import investorsPricing from 'modules/investors/pricing/routes'
import investorsStrategies from 'modules/investors/strategies/routes'
import leadRoutes from 'modules/leads/routes'
import botsRoutes from 'modules/market/bots/routes'
import marketsRoutes from 'modules/market/markets/routes'
import matchingRoutes from 'modules/matching/routes'
import partnersRoutes from 'modules/partners/routes'
import reportsRoutes from 'modules/reports/routes'
import invoiceRoutes from 'modules/requests/invoice/routes'
import payablesRoutes from 'modules/requests/payables/routes'
import settlementRoutes from 'modules/settlement-lock/routes'
import statementsEurRoutes from 'modules/statements-eur/routes'
import statementsGBPRoutes from 'modules/statements-gbp/routes'
import tradesRoutes from 'modules/trades/routes'
import usersRoutes, { ROUTE_NAMES as USER_ROUTES } from 'modules/users/routes'
import { ax, getToken, logout } from 'src/client'
import store from 'src/vuex'
import Vue from 'vue'
import VueRouter from 'vue-router'
import AUTH_TYPES from '../modules/auth/store/types'
import { pageWasRefreshed } from './utils'

const USER_INFO_URL = `${BACKOFFICE_API_URL}/userinfo`

Vue.use(VueRouter)

const routerOptions = {
  mode: 'history',
  linkActiveClass: 'active',
  routes: [].concat(
    authRoutes,
    {
      name: 'home',
      path: '/',
      redirect: { name: USER_ROUTES.LIST },
      component: (resolve) => require(['components/App'], resolve),
      children: [].concat(
        botsRoutes,
        investorsCompaniesRoutes,
        companiesRoutes,
        etrRoutes,
        etpRoutes,
        invoiceRoutes,
        creditRoutes,
        marketsRoutes,
        partnersRoutes,
        leadRoutes,
        investorsStrategies,
        investorsPricing,
        investorsPositions,
        accountStatements,
        tradesRoutes,
        settlementRoutes,
        instructionsEurRoutes,
        statementsEurRoutes,
        instructionsGBPRoutes,
        statementsGBPRoutes,
        debtCollectionRoutes,
        matchingRoutes,
        usersRoutes,
        rolesRoutes,
        payablesRoutes,
        reportsRoutes,
        accountingRoutes
      )
    },
    {
      path: '*',
      component: (resolve) => require(['components/NotFound'], resolve)
    }
  )
}

const router = new VueRouter(routerOptions)

router.beforeEach((to, from, next) => {
  const token = getToken()
  let result = Promise.resolve()
  result
    .then(() => {
      // 404
      if (!to.matched.length) {
        return { path: '/' }
      }
    })
    .then((dir) => {
      if (dir) return dir

      // If logging out
      if (to.name === AUTH_ROUTES.LOGOUT) {
        logout()
      }
    })
    .then((dir) => {
      if (dir) return dir
      const userId = store.getters[AUTH_TYPES.GET_USER_ID]
      let promise = Promise.resolve(token)
      if (pageWasRefreshed(from) && !userId && token) {
        promise = new Promise((resolve) => {
          ax.get(USER_INFO_URL)
            .then((data) => {
              store.dispatch(AUTH_TYPES.UPDATE_DATA, {
                token,
                user: data
              })
              resolve(token)
            })
            .catch(() => resolve())
        })
      }

      return promise.then((token) => {
        if (
          to.matched.some((record) => record.meta.skipIfAuthenticated) &&
          token
        ) {
          // If tries to see a route that requires authentication and it is not authenticated
          return { name: USER_ROUTES.LIST }
        } else if (to.name !== AUTH_ROUTES.LOGIN && !token) {
          // If while authenticated reaches a route that is only visible if not authenticated
          return { name: AUTH_ROUTES.LOGIN }
        } else {
          // Do nothing
          return
        }
      })
    })
    .then((dir) => {
      next(dir)
    })
})

export default router
